import script from "./SearchView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchView.vue?vue&type=script&setup=true&lang=ts"

import "./SearchView.vue?vue&type=style&index=0&id=d7419168&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7419168"]])

export default __exports__